const WEBROOT = process.env.REACT_APP_WEBROOT

const BASE_URL = process.env.REACT_APP_API_ROOT

const API_ROOT = BASE_URL + "api/"

const PHOTOS_ROOT = BASE_URL + "image/annonces/"

const AVATAR_ROOT = BASE_URL + "image/profile/"

const AVATAR_DEFAULT = "/image/avatar.png"

const PHOTO_BLOG_ROOT = BASE_URL + "image/blog/"

const APP_NAME = "Sisters Green"

const PLANTSITTING_COM = 4.5
const PLANTSITTING_COM_PER = 0.05

if (process.env.REACT_APP_ENV === 'preproduction') {
    console.warn("⚠️ Environnement de DEV / PRÉPROD ⚠️");
}

// API

const API_SECRET = "123123"

export { WEBROOT, API_ROOT, APP_NAME, API_SECRET, AVATAR_ROOT, AVATAR_DEFAULT, PHOTOS_ROOT, PHOTO_BLOG_ROOT, PLANTSITTING_COM, PLANTSITTING_COM_PER };